import React, { Component } from 'react';
import { firebaseRef } from '../firebase.js';
import { withRouter } from 'react-router';
import Inputbutton from './Inputbutton.js';
import Inputmain from './Inputmain.js';
import Inputnormal from './Inputnormal.js';
import Inputorder from './Inputorder.js';
import Pinput from './Pinput.js';
class Buttons extends Component {
  constructor(props){
    super(props);
    this.state = {
      checkOcRt: '',
      comment: '',
      order: [],
      first: '',
      second: '',
      mainButtons: [],
      pArray: [],
      p1Check: '',
      mainAfter: [],
      highlight: '',
      P4Opacity: false,
      special: false
    };
    this.checkOcRt = this.checkOcRt.bind(this);
    this.commentChange = this.commentChange.bind(this);
    this.order = this.order.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.mainButtons = this.mainButtons.bind(this);
    this.pCheck = this.pCheck.bind(this);
    this.p1Check = this.p1Check.bind(this);
    this.mainAfter = this.mainAfter.bind(this);
  }

  checkOcRt(event){
    if (this.state.checkOcRt === event.target.value) {
      this.setState({ checkOcRt: '' });
    }else{
    this.setState({ checkOcRt: event.target.value });
  }
}

handleSubmit(){
  var that=this;
  var m =new Date();
  var month = m.getMonth() + 1;
  var date = month +'/'+ m.getDate() +'/'+ m.getFullYear();
  var main = this.state.mainButtons.toString();
  var mainAfter = this.state.mainAfter.toString();
  var pArray = this.state.pArray.toString();
  var order = this.state.order.toString();
  var user = this.props.match.params.user;
  var doctor = firebaseRef.auth().currentUser.uid;
  var refMain = firebaseRef.database().ref('doctors/'+doctor+'/users/'+user+'/buttons');
  refMain.push({
    pArray: pArray,
    order: order,
    main: main,
    p1Check: that.state.p1Check,
    ocrt: that.state.checkOcRt,
    mainAfter: mainAfter,
    comment: that.state.comment,
    date: date,
  }).then(function(){
    that.setState({
      checkOcRt: '',
      comment: '',
      order: [],
      first: '',
      second: '',
      mainButtons: [],
      pArray: [],
      p1Check: '',
      mainAfter: [],
      special: false
    })
  });
}

componentDidMount(){
  this.state.order.toString();
}

mainButtons(event){
  var value = event.target.value;
  if (this.state.mainButtons.indexOf(value) > -1) {
      var index = this.state.mainButtons.indexOf(value);
      this.state.mainButtons.splice(index,1);
  }else{
  this.state.mainButtons.push(value);
}
}

mainAfter(event){
  var value = event.target.value;
  if (this.state.mainAfter.indexOf(value) > -1) {
      var index = this.state.mainAfter.indexOf(value);
      this.state.mainAfter.splice(index,1);
  }else{
  this.state.mainAfter.push(value);
}
}

commentChange(event){
  this.setState({ comment: event.target.value });
}

order(event){
  if (this.state.order.indexOf(event.target.value) > -1 ) {
    var index = this.state.order.indexOf(event.target.value);
    this.state.order.splice(index,1);
    this.setState({ first: this.state.order[0], second: this.state.order[1] });
  }else{
  if (this.state.order.length === 2) {
    this.state.order.shift();
  }
  this.state.order.push(event.target.value);
  this.setState({ first: this.state.order[0], second: this.state.order[1] });
}
}

pCheck(event){
  var value = event.target.value;
  if (this.state.pArray.indexOf(value) > -1) {
    var index = this.state.pArray.indexOf(value);
    this.state.pArray.splice(index,1);
    this.setState({ highlight: '', special: false });
  }else{
  this.state.pArray.push(value);
  if (value === 'P5-Flx' || value ==='P5-LB' || value === 'P4') {
    if (value === 'P5-Flx') {
      this.setState({ highlight: 'P2' });
    }if(value === 'P5-LB'){
      this.setState({ highlight: 'P3Spec', special: true });
    }if (value === 'P4') {
      this.setState({ highlight: 'P4' });
    }

  }else{
    this.setState({ highlight: value, special: false });
  }
}
}

p1Check(event){
  if (this.state.p1Check === '') {
    this.setState({ p1Check: event.target.value });
  }else{
    this.setState({ p1Check: '' });
  }

}

  render(){
    return(
        <div className="grid-forms" style={{marginTop: 10}}>
          <form className="buttons">
          <div className="flex-inner-divs-buttons">
            <Inputorder title="B" group="B" click={this.order} first={this.state.first} second={this.state.second}/>
            <Inputorder title="E" group="E" click={this.order} first={this.state.first} second={this.state.second}/>
            <Inputorder title="LM" group="LM" click={this.order} first={this.state.first} second={this.state.second}/>
            <Inputorder title="UM" group="UM" click={this.order} first={this.state.first} second={this.state.second}/>
            <Inputorder title="SL" group="SL" click={this.order} first={this.state.first} second={this.state.second}/>
          </div>
            <div className="flex-inner-divs-buttons" style={{marginTop: 20}}>
              <Inputbutton title="P2" group="P2" main="buttons" click={this.pCheck} check={this.state.pArray}/>
              <Inputbutton title="P3" group="P3" main="buttons" click={this.pCheck} check={this.state.pArray}/>
              <Inputbutton title="P4" group="P4" main="buttons" click={this.pCheck} check={this.state.pArray}/>
              <Inputbutton title="P5-Flx" group="P5-Flx" main="buttons" click={this.pCheck} check={this.state.pArray}/>
              <Inputbutton title="P5-LB" group="P5-LB" main="buttons" click={this.pCheck} check={this.state.pArray}/>
            </div>
            <div style={{marginTop: 15, display: 'flex'}}>
            <div className="inline-grid-forms">
              <div className="flex-inner-divs-buttons flex-end-div">
                <div className="grid-forms">
                  <div className="flex-divs border-divs"><h3>Left</h3></div>
                  <div className="flex-inner-divs">
                      <div className="flex-divs buttons-title"><h3>LB</h3></div>
                      <div className="flex-divs buttons-title"><h3>Flex</h3></div>
                  </div>
                </div>
                <div className="grid-forms">
                  <div className="flex-divs border-divs"><h3>Right</h3></div>
                  <div className="flex-inner-divs">
                      <div className="flex-divs buttons-title"><h3>Flex</h3></div>
                      <div className="flex-divs buttons-title"><h3>LB</h3></div>
                  </div>
                </div>
              </div>
                <div className={`flex-inner-divs-buttons ${this.state.pArray.length > 0 && this.state.highlight !== 'P2' ? 'highlight' : ''}`}>
                  <div className="flex-divs buttons-title"><h3>C1/0</h3></div>
                  <Inputmain group="Left-lb-C1/0" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Left-flx-C1/0" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Right-flx-C1/0" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Right-lb-C1/0" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                </div>
                <div className={`flex-inner-divs-buttons ${this.state.pArray.length > 0 && this.state.highlight !== 'P2' ? 'highlight' : ''}`}>
                  <div className="flex-divs buttons-title"><h3>C1/2</h3></div>
                  <Inputmain group="Left-lb-C1/2" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Left-flx-C1/2" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Right-flx-C1/2" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Right-lb-C1/2" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                </div>
                <div className={`flex-inner-divs-buttons ${this.state.pArray.length > 0 && this.state.highlight !== 'P4' ? 'highlight' : ''} ${this.state.pArray.length > 0 && this.state.highlight === 'P3Spec' ? 'highlight-spec' : ''}`}>
                  <div className="flex-divs buttons-title"><h3>C2/1</h3></div>
                  <Inputmain group="Left-lb-C2/1" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Left-flx-C2/1" click={this.mainButtons} check={this.state.mainButtons} special={this.state.special}/>
                  <Inputmain group="Right-flx-C2/1" click={this.mainButtons} check={this.state.mainButtons} special={this.state.special}/>
                  <Inputmain group="Right-lb-C2/1" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                </div>
                <div className={`flex-inner-divs-buttons ${this.state.pArray.length > 0 && this.state.highlight !== 'P4' ? 'highlight' : ''} ${this.state.pArray.length > 0 && this.state.highlight === 'P3Spec' ? 'highlight-spec' : ''}`}>
                  <div className="flex-divs buttons-title"><h3>C2/3</h3></div>
                  <Inputmain group="Left-lb-C2/3" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Left-flx-C2/3" click={this.mainButtons} check={this.state.mainButtons} special={this.state.special}/>
                  <Inputmain group="Right-flx-C2/3" click={this.mainButtons} check={this.state.mainButtons} special={this.state.special}/>
                  <Inputmain group="Right-lb-C2/3" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                </div>
                <div className={`flex-inner-divs-buttons ${this.state.pArray.length > 0 && this.state.highlight !== 'P4' ? 'highlight' : ''} ${this.state.pArray.length > 0 && this.state.highlight === 'P3Spec' ? 'highlight-spec' : ''}`}>
                  <div className="flex-divs buttons-title"><h3>C3/2</h3></div>
                  <Inputmain group="Left-lb-C3/2" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Left-flx-C3/2" click={this.mainButtons} check={this.state.mainButtons} special={this.state.special}/>
                  <Inputmain group="Right-flx-C3/2" click={this.mainButtons} check={this.state.mainButtons} special={this.state.special}/>
                  <Inputmain group="Right-lb-C3/2" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                </div>
                <div className={`flex-inner-divs-buttons ${this.state.pArray.length > 0 && this.state.highlight !== 'P4' ? 'highlight' : ''} ${this.state.pArray.length > 0 && this.state.highlight === 'P3Spec' ? 'highlight-spec' : ''}`}>
                  <div className="flex-divs buttons-title"><h3>C3/4</h3></div>
                  <Inputmain group="Left-lb-C3/4" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Left-flx-C3/4" click={this.mainButtons} check={this.state.mainButtons} special={this.state.special}/>
                  <Inputmain group="Right-flx-C3/4" click={this.mainButtons} check={this.state.mainButtons} special={this.state.special}/>
                  <Inputmain group="Right-lb-C3/4" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                </div>
                <div className={`flex-inner-divs-buttons ${this.state.pArray.length > 0 && this.state.highlight !== 'P2' ? 'highlight' : ''}`}>
                  <div className="flex-divs buttons-title"><h3>C4/3</h3></div>
                  <Inputmain group="Left-lb-C4/3" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Left-flx-C4/3" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Right-flx-C4/3" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Right-lb-C4/3" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                </div>
                <div className={`flex-inner-divs-buttons ${this.state.pArray.length > 0 && this.state.highlight !== 'P2' ? 'highlight' : ''}`}>
                  <div className="flex-divs buttons-title"><h3>C4/5</h3></div>
                  <Inputmain group="Left-lb-C4/5" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Left-flx-C4/5" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Right-flx-C4/5" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Right-lb-C4/5" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                </div>
                <div className={`flex-inner-divs-buttons ${this.state.pArray.length > 0 && this.state.highlight !== 'P2' ? 'highlight' : ''}`}>
                  <div className="flex-divs buttons-title"><h3>C5/4</h3></div>
                  <Inputmain group="Left-lb-C5/4" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Left-flx-C5/4" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Right-flx-C5/4" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Right-lb-C5/4" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                </div>
                <div className={`flex-inner-divs-buttons ${this.state.pArray.length > 0 && this.state.highlight !== 'P2' ? 'highlight' : ''}`}>
                  <div className="flex-divs buttons-title"><h3>C5/6</h3></div>
                  <Inputmain group="Left-lb-C5/6" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Left-flx-C5/6" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Right-flx-C5/6" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Right-lb-C5/6" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                </div>
                <div className={`flex-inner-divs-buttons ${this.state.pArray.length > 0 && this.state.highlight !== 'P2' ? 'highlight' : ''}`}>
                  <div className="flex-divs buttons-title"><h3>C6/5</h3></div>
                  <Inputmain group="Left-lb-C6/5" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                  <Inputmain group="Left-flx-C6/5" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                  <Inputmain group="Right-flx-C6/5" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                  <Inputmain group="Right-lb-C6/5" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                </div>
                <div className={`flex-inner-divs-buttons ${this.state.pArray.length > 0 && this.state.highlight !== 'P2' ? 'highlight' : ''}`}>
                  <div className="flex-divs buttons-title"><h3>C6/7</h3></div>
                  <Inputmain group="Left-lb-C6/7" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                  <Inputmain group="Left-flx-C6/7" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                  <Inputmain group="Right-flx-C6/7" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                  <Inputmain group="Right-lb-C6/7" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                </div>
                <div className={`flex-inner-divs-buttons ${this.state.pArray.length > 0 && this.state.highlight !== 'P2' ? 'highlight' : ''}`}>
                  <div className="flex-divs buttons-title"><h3>C7/6</h3></div>
                  <Inputmain group="Left-lb-C7/6" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                  <Inputmain group="Left-flx-C7/6" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                  <Inputmain group="Right-flx-C7/6" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                  <Inputmain group="Right-lb-C7/6" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                </div>
                <div className={`flex-inner-divs-buttons ${this.state.pArray.length > 0 && this.state.highlight !== 'P2' ? 'highlight' : ''}`}>
                  <div className="flex-divs buttons-title"><h3>C7/8</h3></div>
                  <Inputmain group="Left-lb-C7/8" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                  <Inputmain group="Left-flx-C7/8" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                  <Inputmain group="Right-flx-C7/8" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                  <Inputmain group="Right-lb-C7/8" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                </div>
                <div className={`flex-inner-divs-buttons ${this.state.pArray.length > 0 && this.state.highlight !== 'P2' ? 'highlight' : ''}`}>
                  <div className="flex-divs buttons-title"><h3>C8/7</h3></div>
                  <Inputmain group="Left-lb-C8/7" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Left-flx-C8/7" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Right-flx-C8/7" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                  <Inputmain group="Right-lb-C8/7" click={this.mainButtons} check={this.state.mainButtons} special={false}/>
                </div>
                <div className={`flex-inner-divs-buttons ${this.state.pArray.length > 0 && this.state.highlight !== 'P3' ? 'highlight' : ''} ${this.state.pArray.length > 0 && this.state.highlight === 'P3Spec' ? 'highlight-spec' : ''}`}>
                  <div className="flex-divs buttons-title"><h3></h3></div>
                  <div className="flex-divs buttons-title"><h3>PL</h3></div>
                  <div className="flex-divs buttons-title"><h3>SI</h3></div>
                  <div className="flex-divs buttons-title"><h3>SI</h3></div>
                  <div className="flex-divs buttons-title"><h3>PL</h3></div>
                </div>
                <div className={`flex-inner-divs-buttons ${this.state.pArray.length > 0 && this.state.highlight !== 'P3' ? 'highlight' : ''} ${this.state.pArray.length > 0 && this.state.highlight === 'P3Spec' ? 'highlight-spec' : ''}`}>
                  <div className="flex-divs buttons-title"><h3 style={{visibility: 'hidden'}}>SI</h3></div>
                  <Inputmain group="Left-lb-PL" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                  <Inputmain group="Left-flx-SI" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                  <Inputmain group="Right-flx-SI" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                  <Inputmain group="Right-lb-PL" click={this.mainButtons} check={this.state.mainButtons} special={false} />
                </div>
              </div>

            <div className="grid-forms" style={{display: 'inline-block', marginLeft: '15%'}}>
              <div className="flex-inner-divs-buttons">
                  <Pinput title="P1" group="P1" click={this.p1Check} check={this.state.p1Check}/>
                 <div className="flex-divs buttons-title"><h3></h3></div>
                 <div className="flex-divs buttons-title"><h3>LT</h3></div>
                 <div className="flex-divs buttons-title"><h3>RT</h3></div>
                 <Inputnormal title="Oc Rt" group="Oc-Rt" checking={this.state.checkOcRt} click={this.checkOcRt} main="button"/>
              </div>
                <div className="flex-inner-divs-buttons flex-end-div">
                 <div className="flex-divs buttons-title"><h3>S1</h3></div>
                  <Inputmain group="S1-LT" click={this.mainAfter} check={this.state.mainAfter} special={false} />
                  <Inputmain group="S1-RT" click={this.mainAfter} check={this.state.mainAfter} special={false} />
                  <Inputnormal title="Oc Lt" group="Oc-Lt" checking={this.state.checkOcRt} click={this.checkOcRt} main="button"/>
                </div>
                <div className="flex-inner-divs-buttons flex-center-div">
                 <div className="flex-divs buttons-title"><h3>S2</h3></div>
                  <Inputmain group="S2-LT" click={this.mainAfter} check={this.state.mainAfter} special={false} />
                  <Inputmain group="S2-RT" click={this.mainAfter} check={this.state.mainAfter} special={false} />
                </div>
                <div className="flex-inner-divs-buttons flex-center-div">
                 <div className="flex-divs buttons-title"><h3>S3</h3></div>
                  <Inputmain group="S3-LT" click={this.mainAfter} check={this.state.mainAfter} special={false} />
                  <Inputmain group="S3-RT" click={this.mainAfter} check={this.state.mainAfter} special={false} />
                </div>
                <div className="flex-inner-divs-buttons flex-center-div">
                 <div className="flex-divs buttons-title"><h3>S4</h3></div>
                  <Inputmain group="S4-LT" click={this.mainAfter} check={this.state.mainAfter} special={false} />
                  <Inputmain group="S4-RT" click={this.mainAfter} check={this.state.mainAfter} special={false} />
                </div>
                <div className="flex-inner-divs-buttons flex-center-div">
                 <div className="flex-divs buttons-title"><h3>S5</h3></div>
                  <Inputmain group="S5-LT" click={this.mainAfter} check={this.state.mainAfter} special={false} />
                  <Inputmain group="S5-RT" click={this.mainAfter} check={this.state.mainAfter} special={false} />
                </div>
                <div style={{marginTop: '20%'}}>
                  <textarea placeholder="Add a Comment to This Tretment..." ref={(input) => { this.nameInput = input; }} style={{width: '100%', height: 150}} value={this.state.comment} onChange={this.commentChange}></textarea>
                </div>
                <div className="flex-divs">
                <input type="button" className="button-forms" style={{width: '100%'}} value="Submit Buttons" onClick={this.handleSubmit} />
                </div>
            </div>
            </div>

          </form>
        </div>
    );
  }
}

export default withRouter(Buttons);



// WEBPACK FOOTER //
// ./src/routes/Paitent/Buttons.js